module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.consoBooking.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.getReports
    }
  }, [_vm._v("Export as Excel\n            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('md-layout', {
    staticClass: "align-items-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentTypeFilter),
      callback: function($$v) {
        _vm.shipmentTypeFilter = $$v
      },
      expression: "shipmentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    model: {
      value: (_vm.fclLclFilter),
      callback: function($$v) {
        _vm.fclLclFilter = $$v
      },
      expression: "fclLclFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr align-items-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerFilter),
      callback: function($$v) {
        _vm.containerFilter = $$v
      },
      expression: "containerFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4 justify-content-center"
  }, [_c('div', [_c('b-button', {
    staticStyle: {
      "margin-right": "0.5rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-right": "0.5rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("Filters")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Type : " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ? "Sea" : "Air") + "\n                " + _vm._s(row1.item.transportType) + ") -\n                " + _vm._s(row1.item.containerInfo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Date : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.baseLoc))])]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' &&
          row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                Client Name : " + _vm._s(row11.item.exporter) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "mainEnquirySeries",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.mainEnquirySeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Type : " + _vm._s(row2.item.EnqJob) + " (" + _vm._s(row2.item.shipmentType == "1" ? "Sea" : "Air") + "\n                " + _vm._s(row2.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row2.item.enqDate)))])]
      }
    }, {
      key: "POR",
      fn: function(row7) {
        return [(row7.item.shipmentType == '1') ? _c('div', [_c('span', [_vm._v("Container Type :\n                  " + _vm._s(row7.item.multipleContainerType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("No of Containers : " + _vm._s(row7.item.multiConNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Shipping Line : " + _vm._s(row7.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pickup : " + _vm._s(row7.item.pickup))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Stuffing : " + _vm._s(row7.item.stuffingLoc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Handover : " + _vm._s(row7.item.handover))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Place of Receipt : " + _vm._s(row7.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), (row7.item.jobType.split(',').includes('FF')) ? _c('div', [_c('span', [_vm._v("Load Port : " + _vm._s(row7.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Port of Discharge : " + _vm._s(row7.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Final Place of Delivery :\n                    " + _vm._s(row7.item.finalPlace))])]) : _vm._e()]) : _c('div', [_c('span', [_vm._v("\n                  Departure Airport : " + _vm._s(row7.item.AirDept) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  Destination Airport : " + _vm._s(row7.item.airDesti) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  No.of Packages : " + _vm._s(row7.item.noOfPkg) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  Cargo Received At :\n                  " + _vm._s(row7.item.cargoReceived == "1" ? "Airport" : "Warehouse") + "\n                  "), _c('br')])])]
      }
    }, {
      key: "deleteRequest",
      fn: function(row10) {
        return [_c('td', [(row10.item.deleteRequest == '0') ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '1',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Request To Delete Assignment")]) : _vm._e(), _vm._v(" "), (row10.item.deleteRequest == '0') ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Sent For Delete Approval")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2' &&
          (_vm.$sessionsStorage.get('designation') == 'Admin' ||
            _vm.$sessionsStorage.get('designation') == 'HOD')
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '2',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Approve Delete Request /")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '3',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Reject Delete Request")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '0' &&
          row10.item.ApproveRejectDelReq != '2'
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.ApproveRejectDelReq == '2' &&
          row10.item.asignDeleted != '1'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '4',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Delete Assignment")]) : _vm._e(), _vm._v(" "), (row10.item.asignDeleted == '1') ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Assignment Deleted")]) : _vm._e()])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-004f592e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/salesReports.vue
// module id = 2347
// module chunks = 0